._ClientIntegrations_1c3no_1 ._applicationsLink_1c3no_1 {
  user-select: none;
  cursor: pointer;
  color: #3996e0;
}